<template>
    <div class="d-flex flex-column align-items-center px-4 py-2">
        <span class="font-md font-weight-bold text-gray-dk">Your session has expired</span>
        <span class="font-xs text-secondary mb-4 mt-2">Please login and try your transaction again.</span>
        <button type="button" class="btn btn-danger rounded-lg font-xs px-4 py-2" @click="close">Back to Login</button>
    </div>
</template>
<script>
export default {
    methods:{
        close() {
            let g4params = {
                'userId': sessionStorage.getItem("userId"),
                'cuid': sessionStorage.getItem("cuid"),
                'ip': sessionStorage.getItem("ip"),
                'user_agent': sessionStorage.getItem("user_agent"),
                'phone': sessionStorage.getItem("phone"),
                'operating_system': sessionStorage.getItem("operating_system"),
                'browser': sessionStorage.getItem("browser"),
                'transaction_type': sessionStorage.getItem("transaction_type"),
                'transaction_reference': sessionStorage.getItem("transaction_reference"),
            }       
            this.triggerG4Event('idle_logout_click_back_to_login',g4params)
            // sessionStorage.clear();
            this.$attrs.options.promiseResolver();
        },
        triggerG4Event(name, params = {}){
            if (typeof gtag === 'function'){
                gtag("event", name , params)
            } else{
                console.log('GTAG Func Not Defined')
            }
        }
    }
}
</script>